import axios, { AxiosError, AxiosResponse } from 'axios';
import { parseAxiosError } from '../Utils/common';
import { Buffer } from 'buffer';

axios.interceptors.request.use(
    config => {
        const id = sessionStorage.getItem("id")
        if (id) {
            config.headers['x-api-key'] = id;
            config.headers['Cache-Control'] = "no-cache";
        }
        return config
    },
    error => {
        Promise.reject(error)
    }
)

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error)
    }
)


export const getGeoLocation = async (lat: any, lng: any) => {
    const URL = `/api/form/geoLocation/${lat}/${lng}`
    try {
        var config = {
            method: 'get',
            url: URL,
        };
        const response = await axios(config)
        return response?.data?.data

    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const getInternalToken = async (tokenId: string): Promise<any> => {
    try {
        const response = await axios.get(`/api/auth/getInternalToken?id=${tokenId}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getConfig = async (internalId: string, publicUUID: string): Promise<any> => {
    try {
        const response = await axios.get(`/api/auth/getConfig?internalUUID=${internalId}&publicUUID=${publicUUID}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const testIntegration = async (workspace_id: string, domain: string) => {
    try {
        let response = await axios.post(`/api/auth/integration`, { workspace_id, domain });
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: { "snippetInstalled": false }
        }
    }
}

export const getForms = async (
    searchValue: string,
    sortOption: string,
    sortByDate: string,
    filterOption: string,
    filterValue: string,
    principalId: string,
    page: number = 1,
    pageSize: number = 12
) => {
    try {
        const url = `/api/form/getforms?searchValue=${searchValue}&sortOption=${sortOption}&sortByDate=${sortByDate}&filterOption=${filterOption}&filterValue=${filterValue}&principalId=${principalId}&page=${page}&pageSize=${pageSize}`;
        let response = await axios.get(url);
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: "",
        };
    }
};
export const getFormsByFilter = async (
    searchValue: string,
    principalId: string
) => {
    try {
        const url = `/api/form/getformsByFilter?searchValue=${searchValue}&principalId=${principalId}`;
        let response = await axios.get(url);
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: "",
        };
    }
};
export const insertForms = async (formData: any) => {
    try {
        const url = `/api/form/insertDocument`
        let response = await axios.post(url, formData);
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const publishForms = async (formArray: any) => {
    try {
        let config = {
            method: 'put',
            url: `/api/form/publishForms`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                formUUIDs: formArray
            }
        };
        let response = await axios(config);
        return response?.data;
    } catch (error) {
        return {
            status: 500,
            err: error,
            data: ""
        }
    }
}

export const restoreForm = async (formUUIDs: any) => {
    try {
        let config = {
            method: 'put',
            url: `/api/form/restoreForm`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: { formUUIDs }
        };
        let response = await axios(config);
        return response?.data;
    } catch (error) {
        return {
            status: 500,
            err: error,
            data: ""
        }
    }
}

export const multiDeleteForms = async (formArray: any, mode: string) => {
    try {
        let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `/api/form/multiForms`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                formUUIDs: formArray,
                mode: mode
            }
        };
        let response = await axios(config);
        return response?.data;
    } catch (error) {
        return {
            status: 500,
            err: error,
            data: ""
        }
    }
}

export const getFormsByUUID = async (formUUID: string, principalId: string) => {
    try {
        const url = `/api/form/getformsByUUID?formUUID=${formUUID}&principalId=${principalId}`
        let response = await axios.get(url);
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const updateFormByUUID = async (formData: any) => {
    try {
        const url = `/api/form/updateFormByUUID`
        let response = await axios.post(url, formData);
        return response;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const getAccessLink = async (details: any) => {
    try {
        const url = `/api/form/getAccessLink`
        let response = await axios.post(url, details);
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const getUserAccess = async (details: any) => {
    try {
        const url = `/api/form/getUserAccess`
        let response = await axios.post(url, details);
        return response?.data?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const createAccessLink = async (details: any) => {
    try {
        const url = `/api/form/createAccessLink`
        let response = await axios.post(url, details);
        return response?.data?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const deleteFormByUUID = async (formUUID: string, principalId: string, mode: string) => {
    try {
        const url = `/api/form/deleteFormByUUID?formUUID=${formUUID}&principalId=${principalId}&mode=${mode}`
        let response = await axios.get(url);
        return response;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const duplicateFormByUUID = async (formUUID: string) => {
    try {
        const url = `/api/form/duplicateDocument/${formUUID}`
        let response = await axios.get(url);
        return response;
    } catch (error) {
        return {
            status: 400,
            err: error,
            data: ""
        }
    }
}

export const uploadBackground = async (formData: any, formUUID: string, principalId: string) => {
    const url = `/api/form/uploadBackground`;
    try {
        const response = await axios.post(`${url}?formUUID=${formUUID}&principalId=${principalId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data
    } catch (error) {
        return {
            status: 400,
            err: error,
            data: ""
        }
    }
}

export const insertPayment = async (details: any) => {
    const url = `/api/form/insertPayment`;
    try {
        const response = await axios.post(url, details);
        return response.data
    } catch (error) {
        return {
            status: 400,
            err: error,
            data: ""
        }
    }
}

export const getDropdownApi = async (data: any) => {

    try {
        var config: any = {
            method: 'get',
            url: data?.dropdown_endPoint,
        };
        if (data?.dropdown_endPointHeaders) config["headers"] = JSON.parse(data?.dropdown_endPointHeaders);
        const response = await axios(config);
        return response?.data;
    } catch (error) {
        console.log("error in send to endpoint");
    }
}

export const getUserTemplatesFromBuilder = async (
    token: string,
    sortOption: string,
    limit: number
) => {
    const url = `/api/template/getUserTemplates?sortBy=${sortOption}&limit=${limit}`;

    let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: url,
        headers: {
            authorization: `${token}`,
        },
    };

    try {
        const response: AxiosResponse = await axios.request(config);
        return response.data;
    } catch (error) {
        return {
            status: 400,
            err: error,
            data: "",
        };
    }
};

export const getHtmlContentBasedOnId = async (templateId: string) => {
    const url = `/api/template/htmlContent?templateId=${templateId}`;
    const config = { method: "get", maxBodyLength: Infinity, url: url };

    try {
        const response: AxiosResponse = await axios.request(config);

        return response.status === 200 ? response.data : null;
    } catch (error) {
        return null;
    }
};

export const getPreviewLink = async (formUUID: any) => {
    try {
        let response = await axios.get(`/api/form/previewLink?formUUID=${formUUID}`);
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const getGroups = async (page: number = 1) => {
    const config = {
        url: `/api/form/groups?page=${page}&perPage=100`,
        headers: {
            Authorization: 'Basic ' + Buffer.from(sessionStorage.principalId).toString('base64')
        }
    }
    try {
        const response = await axios(config);
        return response.data
    } catch (error) {
        return {
            status: 400,
            err: error,
            data: ""
        }
    }
}

export const saveGroups = async (name: any) => {
    const config = {
        method: "POST",
        url: `/api/form/groups`,
        headers: {
            Authorization: 'Basic ' + Buffer.from(sessionStorage.principalId).toString('base64')
        },
        data: name
    }
    try {
        const response = await axios(config);
        return response?.data
    } catch (error: AxiosError | any) {

        return (error?.response?.data as AxiosError) || parseAxiosError(error);
    }
}

export const getUpdatedFormLink = async (auth: string) => {
    const config = {
        method: 'GET',
        url: `/api/form/updatedFormLink`,
        headers: {
            Authorization: 'Bearer ' + auth
        }
    }
    try {
        const response = await axios(config);
        return response.data
    } catch (error) {
        return {
            status: 500,
            err: error,
            data: ""
        }
    }
}

export const createFormWithAi = async (details: any) => {
    const config = {
        method: 'POST',
        url: `/api/form/aiForm`,
        data: details
    }
    try {
        const response = await axios(config);
        return response.data
    } catch (error) {
        return {
            status: 500,
            err: error,
            data: ""
        }
    }
}

export const getIframeUrl = async () => {
    try {
        const response = await axios(`/api/form/iframeUrl`, {
            headers: { 'authorization': sessionStorage.getItem('auth_token') }
        });
        return response?.data
    } catch (error) {
        return {
            status: 500,
            err: error,
            data: ""
        }
    }
}

export const sendWaymoreSystemEvents = async (formDetails: any) => {

    const config = {
        method: 'POST',
        url: `https://waymore-account-service.connect.waymore.io/api/events/sendWaymoreSystemEvents`,
        headers: { 'authorization': `Bearer ${sessionStorage.getItem('auth_token')}` },
        data: formDetails
    }

    try {
        const response = await axios(config);
        return response
    } catch (error) {
        console.error(error);
        return error;
    }
}

export const getChartList = async (principalId: string) => {
    try {
        const url = `/api/organization/chartList?principalId=${principalId}`
        let response = await axios.get(url);
        return response?.data;
    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}

export const getEmbedForm = async (formUUID: string) => {
    try {
        const config = {
            method: 'GET',
            url: `/api/embed/configAll?formUUID=${formUUID}`,
        };

        const response = await axios(config);
        return response.data;

    } catch (error) {
        console.error("GET error:", error);
        return error;
    }
};

export const postEmbedForm = async (formUUID: string, widgetConfigDetails: any) => {

    try {
        const config = {
            method: 'POST',
            url: `/api/embed/config?formUUID=${formUUID}`,
            data: {
                formUUID: formUUID,
                config: widgetConfigDetails
            }
        };

        const response = await axios(config);
        return response.data;

    } catch (error) {
        console.error("POST error:", error);
        return error;
    }
};

export const putEmbedForm = async (UUID: string, widgetConfigDetails: any, id: any) => {
    try {
        const config = {
            method: 'PUT',
            url: `/api/embed/config?formUUID=${UUID}`,
            data: {
                formUUID: UUID,
                _id: id,
                config: widgetConfigDetails
            }
        };

        const response = await axios(config);
        return response.data;

    } catch (error) {
        console.error("PUT error:", error);
        return error;
    }
};

export const deleteEmbedForm = async (formUUID: string, _id: string) => {
    try {
        const config = {
            method: 'DELETE',
            url: `/api/embed/config`,
            data: {
                _id,
                formUUID
            }
        };

        const response = await axios(config);
        return response.data;

    } catch (error) {
        console.error("DELETE error:", error);
        return error;
    }
};
